module.exports = __webpack_public_path__ + "976b24130f460bdb4ac6303a033a4fa0.wav";